// extracted by mini-css-extract-plugin
module.exports = {"link":"linkbutton_link__w40ZU"};